module.exports = __webpack_public_path__ + "img/company-purple.d55bed79.svg";